import { useEffect, useState, } from 'react';
import { Link, useParams, useHistory, } from 'react-router-dom';
import axios from 'axios';
import htmlParser from 'react-html-parser';

import { GlobalFormats } from '../../classes/main/globalFormats';
import { globalSettings, isUndNullEmp, languageObjGet, LoadingSection, responseGet, sendMessageCloseCurrentWindowAsync } from '../../helpers/settings';
import { forgotPasswordEmailBodyGet } from '../../controllers/emails/emails';
import Menu from '../main/Menu';
import useAuth from '../../controllers/users/useAuth';
const currentMethod = 'ForgotPasswordMessage'

const { app, labels, messages, } = globalSettings;
const { backend, } = app;

export default function ForgotPasswordMessage({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    const auth = useAuth();
    const { id, } = useParams();
    const history = useHistory();
    const [user, setUser] = useState({});
    const [htmlCode, setHtmlCode] = useState('');
    //const [showForgotPasswordMessage, setShowForgotPasswordMessage] = useState(false);
    const [showLoading, setShowLoading] = useState(true);
    const [showData, setShowData] = useState(false);
    //#endregion variables

    //#region methods
    const dataGetAsync = async () => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');
            setShowLoading(true);
            setShowData(false);

            //#region user get data
            //result = await axios?.get(`${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}${backend?.urlNtNr}/${id}`);
            const dataObj = {
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlUsers}${backend?.urlNtNr}/${id}`,
                id: id,
                method: backend?.methods?.getById,
                languageId: languageObj?.id,
            }
            result = await axios?.post(
                dataObj?.url,
                dataObj
            );
            response = result.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                history.push('/');
                return response;
            }

            setUser(response?.result);
            //#endregion get user data

            //#region get html message
            const userLocal = response.result;
            response = forgotPasswordEmailBodyGet({
                userId: userLocal?.id,
                firstName: userLocal?.firstName,
                lastName: userLocal?.lastName,
                urlForgotPassword: userLocal?.urlForgotPasswordEmail,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                setShowData(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                history.push('/');
                return response;
            }

            setHtmlCode(response.result);
            //setShowForgotPasswordMessage(true);

            //#endregion get html message

            //sendMessage(-2, '', 0, false, false, null, '');
            setShowLoading(false);
            setShowData(true);
        } catch (ex) {
            setShowLoading(false);
            setShowData(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync();
    }, []); //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName='home' process='home' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.forgotYourPassword?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.forgotYourPassword?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {!showLoading ?
                            <div>
                                {showData ?
                                    <div>
                                        {!isUndNullEmp({ data: user, subMethod: currentMethod, })?.result ?
                                            <div>
                                                {htmlParser(htmlCode)}
                                            </div>
                                            :
                                            <div></div>
                                        }
                                    </div>
                                    :
                                    <div></div>
                                }
                            </div>
                            :
                            <div className='text-center'
                                style={{ paddingTop: '50px', }}>
                                <LoadingSection alt='loadingSection'
                                    className={globalSettings?.react?.html?.overlay?.textMued}
                                    //className='overlay text-muted'
                                    showText={true}
                                    text={messages?.processing?.[languageObj?.id]}
                                    height={25}
                                    hidden={!showLoading}
                                    languageId={languageObj?.id}
                                    width={25}
                                    subMethod={currentMethod} />
                            </div>
                        }
                        <br />

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>
        </div>
    );
}